
import PDFUtil from '../utils/pdf'

export default {
  data () {
    return {
      maxGralRespChars: 170,
      legend: [
        this.$t('individualReport.data_range'),
        this.$t('individualReport.score'),
        this.$t('individualReport.higher_bold'),
        this.$t('individualReport.lower_sub')
      ]
    }
  },
  methods: {
    truncateGeneral (str) {
      return str.length > this.maxGralRespChars ? str.slice(0, this.maxGralRespChars) + '...' : str
    },
    getGralName (general) {
      const extract = general.match(/(\d+)/)[0]
      const idx = extract - 1
      const name = this.baseQuestionnaire.evaluations.generalEvaluation[idx].description
        ? this.baseQuestionnaire.evaluations.generalEvaluation[idx].description[this.user.lang]
        : this.questionnaire.general[general].name[this.user.lang]

      const text = this.truncateGeneral(name)
      return {
        text: text,
        fontSize: 9,
        margin: [0, 2, 0, 0],
        border: [true, true, true, true],
        style: { color: '#6d7a7a' }
      }
    },
    higherLowerScore (scores = [], score) {
      const lowest = scores[scores.length - 1]

      let text = ''
      let isBold = false
      let isUnderline = false
      let fontSize = 9

      if (isNaN(score)) {
        text = '--'
      } else if (!scores.length) {
        text = score.toFixed(2)
      }

      if (score === scores[0]) {
        isBold = true
        fontSize = 10
        text = score.toFixed(2)
      } else if (score === lowest) {
        isUnderline = true
        text = score.toFixed(2)
      } else {
        text = score.toFixed(2)
      }

      return {
        bold: isBold,
        fontSize: fontSize,
        style: { color: '#2e2d2d' },
        text: text,
        alignment: 'center',
        decoration: isUnderline ? 'underline' : '',
        margin: [0, 3, 0, 0],
        border: [true, true, true, true]
      }
    },
    getResultsHeader (text, topMargin = 11) {
      return {
        bold: true,
        fontSize: 9,
        color: 'white',
        text: text,
        alignment: 'center',
        margin: [2, topMargin, 2, 1],
        border: [true, true, true, true]
      }
    },
    generalResultsTable () {
      const responsibilityResultsTables = []
      const firstTenRows = []
      const remainingRows = []
      const results = this.answersResponsibility.general

      // Get All Scores
      const allScores = []
      for (const key of Object.keys(results)) {
        allScores.push(results[key].score.score)
      }
      allScores.sort((a, b) => b - a)

      // Rows
      for (const general of Object.keys(results)) {
        const data = results[general].score
        const trend = data.score - data.previousScore
        if (firstTenRows.length < 10) {
          firstTenRows.push([
            this.getGralName(general),
            PDFUtil.generateGeneralXDCChartT3(data.range, data.score),
            this.higherLowerScore(allScores, data.score),
            this.getPrevScore(data.previousScore),
            this.getTrend(trend)
          ])
        } else {
          remainingRows.push([
            this.getGralName(general),
            PDFUtil.generateGeneralXDCChartT3(data.range, data.score),
            this.higherLowerScore(allScores, data.score),
            this.getPrevScore(data.previousScore),
            this.getTrend(trend)
          ])
        }
      }

      responsibilityResultsTables.push([
        {
          layout: {
            defaultBorder: '',
            fillColor: function (rowIndex, node, columnIndex) {
              return (rowIndex < 1) ? '#BFBFBF' : undefined
            },
            border: [false, false, false, true]
          },
          table: {
            widths: ['54.5%', '26%', '6%', '6.5%', '7%'],
            headerRows: 1,
            body: [
              [
                this.getResultsHeader(this.gralResponsibilityTitle),
                { layout: { defaultBorder: '', fillColor: '#BFBFBF' },
                  table: {
                    headerRows: 1,
                    body: [[
                      { text: '1\n|', margin: [10, 2, 15, 0] },
                      { text: '2\n|', margin: [0, 2, 15, 0] },
                      { text: '3\n|', margin: [0, 2, 15, 0] },
                      { text: '4\n|', margin: [0, 2, 15, 0] },
                      { text: '5\n|', margin: [0, 2, 15, 0] },
                      { text: '6\n|', margin: [0, 2, 15, 0] }
                    ]]
                  },
                  bold: true,
                  style: { color: '#fff' },
                  fontSize: 9,
                  border: [true, true, true, true]
                },
                this.getResultsHeader(this.$t(`organizationalReport.scores_table_1_sub_header_3`)),
                this.getResultsHeader(this.$t(`organizationalReport.scores_table_1_sub_header_4`), 5),
                this.getResultsHeader(this.$t(`organizationalReport.scores_table_1_sub_header_5`))
              ],
              ...firstTenRows
            ]
          },
          margin: [0, 2, 5, 0],
          border: [false, false, false, true],
          alignment: 'center',
          verticalAlignment: 'center'
        }
      ])

      if (remainingRows.length > 0) {
        responsibilityResultsTables.push([
          {
            layout: {
              defaultBorder: '',
              fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex < 1) ? '#BFBFBF' : undefined
              },
              border: [false, false, false, true]
            },
            table: {
              widths: ['54.5%', '26%', '6%', '6.5%', '7%'],
              headerRows: 1,
              body: [
                [
                  this.getResultsHeader(this.gralResponsibilityTitle),
                  { layout: { defaultBorder: '', fillColor: '#BFBFBF' },
                    table: {
                      headerRows: 1,
                      body: [[
                        { text: '1\n|', margin: [10, 2, 15, 0] },
                        { text: '2\n|', margin: [0, 2, 15, 0] },
                        { text: '3\n|', margin: [0, 2, 15, 0] },
                        { text: '4\n|', margin: [0, 2, 15, 0] },
                        { text: '5\n|', margin: [0, 2, 15, 0] },
                        { text: '6\n|', margin: [0, 2, 15, 0] }
                      ]]
                    },
                    bold: true,
                    style: { color: '#fff' },
                    fontSize: 9,
                    border: [true, true, true, true]
                  },
                  this.getResultsHeader(this.$t(`organizationalReport.scores_table_1_sub_header_3`)),
                  this.getResultsHeader(this.$t(`organizationalReport.scores_table_1_sub_header_4`), 5),
                  this.getResultsHeader(this.$t(`organizationalReport.scores_table_1_sub_header_5`))
                ],
                ...remainingRows
              ]
            },
            margin: [0, 2, 5, 0],
            border: [false, false, false, true],
            alignment: 'center',
            verticalAlignment: 'center',
            pageBreak: 'before'
          }
        ])
      }

      return responsibilityResultsTables
    },
    $generateResultsGral () {
      return [
        PDFUtil.generateTitleLandscape(this.$t('organizationalReport.results_title_1'), 'before', true),
        PDFUtil.generateSubTitleLandscape(this.$t('organizationalReport.results_title_1_sub_1')),
        PDFUtil.generateResultsLegend(this.legend),
        this.generalResultsTable()
      ]
    }
  }
}
